// Modern API client with modular architecture
import { api as baseApi } from './base';
import { AuthApi } from './modules/auth';
import { ProjectsApi } from './modules/projects';
import { BucketsApi } from './modules/buckets';
import { FilesApi } from './modules/files';
import { UploadsApi } from './modules/uploads';
import { StorageApi } from './modules/storage';

// Export individual API modules
export const authApi = new AuthApi();
export const projectsApi = new ProjectsApi();
export const bucketsApi = new BucketsApi();
export const filesApi = new FilesApi();
export const uploadsApi = new UploadsApi();
export const storageApi = new StorageApi();

// Export base API for direct access if needed
export { baseApi };

// Export all types
export * from './types';

// Export errors
export { ApiError } from './base';

// Unified API client (legacy compatibility)
export const apiClient = {
  auth: authApi,
  projects: projectsApi,
  buckets: bucketsApi,
  files: filesApi,
  uploads: uploadsApi,
  storage: storageApi,

  // Base methods for direct access
  get: baseApi.get.bind(baseApi),
  post: baseApi.post.bind(baseApi),
  put: baseApi.put.bind(baseApi),
  patch: baseApi.patch.bind(baseApi),
  delete: baseApi.delete.bind(baseApi),
  upload: baseApi.upload.bind(baseApi),

  // Configuration
  setCsrfToken: baseApi.setCsrfToken.bind(baseApi),
  setOnCsrfTokenUpdate: baseApi.setOnCsrfTokenUpdate.bind(baseApi),
};

// Default export for convenience
export default apiClient;